/*
 * @description:
 * @author: cuicui
 * @Date: 2022-11-29 20:26:41
 * @LastEditTime: 2023-05-13 23:57:36
 * @LastEditors: cuicui
 */
export const refundGet = "/sys/refund";//获取列表
export const refundSeach = (id) => {return "/sys/refund/" + id};//获取列表
export const refundConsent = (id) => {return "/sys/refund/agree/" + id};//同意退款
export const refundRefuse = (id) => {return "/sys/refund/refuse/" + id};//拒绝退款
